export default __webpack_public_path__ + "static/media/double-left-blue.f86744d6.svg";